import React from 'react';
import Backend from './skills/backend';
import Frontend from './skills/frontend';
import DSML from './skills/ds_ml';
import Misc from './skills/misc';
import { DraggableCardContainer } from './skills/draggableCard';
import SkillCard from './skills/SkillCard'; 
import './skills/background.css';

const Skills = () => {
  const skillCategories = [Frontend, Backend, DSML, Misc];

  return (
    <div id="skills" className="w-full flex justify-center py-16 px-4 sm:px-6 lg:px-8">
      <DraggableCardContainer className="w-full max-w-7xl">
        <div className="grid w-full grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 justify-items-center">
          {skillCategories.map((category, idx) => (
            <SkillCard key={idx} category={category} />
          ))}
        </div>
      </DraggableCardContainer>
    </div>
  );
};

export default Skills;